module.exports = __webpack_public_path__ + "static/cover-c32abcd35ac9fe2de453d93b8f9e3c02.png";